const legalListFields = `
  id
  created_at
  language
  role
  title
`;

export default legalListFields;
